import { Component, OnInit } from '@angular/core';
import { GoogleTagManagerService } from 'src/app/services/google-tag-manager.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-btn-whatsapp-border',
  templateUrl: './btn-whatsapp-border.component.html',
  styleUrls: ['./btn-whatsapp-border.component.scss']
})
export class BtnWhatsappBorderComponent implements OnInit {

  textWhatsApp: string | undefined;

  constructor(private gtmService: GoogleTagManagerService) { }

  ngOnInit(): void {
    this.textWhatsApp=environment.contacts.textWhatsappButton
  }

  async onWhatsAppButtonClick() {
    this.gtmService.push({
      event: 'contactWhatsapp'
    });

    window.open(environment.contacts.whatsApp, '_blank');
  }

}
